// lib/apollo-client.js
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const STOREFRONT_URL = process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_URL;
const STOREFRONT_ACCESS_TOKEN = process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN;

if (!STOREFRONT_URL || !STOREFRONT_ACCESS_TOKEN) {
  throw new Error(
    'Shopify storefront credentials missing. Check environment variables.'
  );
}

// HTTP link to Shopify Storefront API
const httpLink = createHttpLink({
  uri: STOREFRONT_URL,
});

// Adding authorization header
const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'X-Shopify-Storefront-Access-Token':
        STOREFRONT_ACCESS_TOKEN,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  ssrMode: typeof window === 'undefined', // Enable SSR mode only on server
});

export default client;
